namespace RioERP.Web.Enums {
    export enum ESubscriptionType {
        ValliditiInDays = 0,
        FixedDate = 1
    }
    Serenity.Decorators.registerEnumType(ESubscriptionType, 'RioERP.Web.Enums.ESubscriptionType');
}
